
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"48","rx":"6","fill":"#EAE3F2"}}),_c('g',{attrs:{"clip-path":"url(#clip0_315_107533)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.75 13.512a2.25 2.25 0 00-2.25 2.25v16.5a2.25 2.25 0 002.25 2.25H27v-3.75a3.75 3.75 0 013.75-3.75h3.75v-11.25a2.25 2.25 0 00-2.25-2.25h-16.5zm18.376 15H30.75a2.25 2.25 0 00-2.25 2.25v3.376c.125-.083.242-.178.349-.285l4.992-4.993.534.535-.534-.535c.107-.107.202-.224.285-.348zm.775 1.41A3.75 3.75 0 0036 27.27V15.762a3.75 3.75 0 00-3.75-3.75h-16.5a3.75 3.75 0 00-3.75 3.75v16.5a3.75 3.75 0 003.75 3.75h11.507a3.75 3.75 0 002.652-1.098l4.992-4.993zM28.843 19.15a.75.75 0 010 1.061l-5.592 5.593a1.57 1.57 0 01-2.218 0l-1.875-1.872a.75.75 0 011.06-1.062l1.875 1.872a.07.07 0 00.098 0l5.592-5.592a.75.75 0 011.06 0z","fill":"#481D72"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_315_107533"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(12 12)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    